// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vant, { Lazyload } from 'vant'
import 'lib-flexible'
import 'vant/lib/index.css'

import App from './App'
import router from './router'
import store from './store'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.use(Vant)
Vue.use(Lazyload)
Vue.config.productionTip = false

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js